import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider, Grid, Header, Popup } from 'semantic-ui-react';
import CustomIcon from '~/components/CustomIcon';
import { StyledGridColumns, StyledGridRow, StyledSegment } from './style';

interface ShowInfoProps {
  showData: any,
}

const ShowInfo: React.FC<ShowInfoProps> = (props: ShowInfoProps) => {
  const { t } = useTranslation();
  const [showData, setShowData] = useState(null);

  useEffect(() => {
    if (props.showData) {
      setShowData(props.showData);
    }
  }, [props]);

  const formatSendDate = (date) => {
    const now = dayjs(new Date());
    const sendDate = dayjs(date);
    return sendDate > now ? '/' : dayjs(date).format(('DD.MM.YYYY HH:mm'));
  };

  const showFarmerGroups = (farmerGroups) => {
    return farmerGroups.map(farmerGroup => farmerGroup.name).join(', ');
  };

  const showAdditionalRecipients = (recipients: string[]) => {
    return recipients.join(', ');
  };

  function getStatusNewsletter(newsletterInfo) {
    let popupMessage
    let iconClass
    if (newsletterInfo?.isDraft) {
      popupMessage = t('Draft')
      iconClass = 'icon-file-milk'
    } else if (newsletterInfo?.isDraft === 0 && newsletterInfo.schedule === 1) {
      popupMessage = (t('Planned'))
      iconClass = 'clock'
    } else if (newsletterInfo?.sent) {
      popupMessage = (t('Sent'))
      iconClass = 'icon-newsletter-1'
    } else {
      popupMessage = t('Sending')
      iconClass = 'envelope'
    }
    return <Popup
      content={popupMessage}
      trigger={<CustomIcon style={{ display: 'grid' }} className={iconClass} />}
    />
  }

  function renderDetails() {
    return <StyledSegment placeholder>
      <Grid columns={2} stackable>
        <Divider vertical />
        <Grid.Row verticalAlign='middle'>
          <Grid.Column>
            <Grid columns={5} stackable>
              <Grid.Row style={{ marginLeft: 10 }}>
                <Header>{showData?.uniqueId}</Header>
              </Grid.Row>
              <StyledGridRow>
                <Grid.Column>{t('Type')}</Grid.Column>
                <StyledGridColumns>{showData?.typeLabel}</StyledGridColumns>
              </StyledGridRow>
              <StyledGridRow>
                <Grid.Column>{t('Status')}</Grid.Column>
                <StyledGridColumns>
                  {getStatusNewsletter(showData)}
                </StyledGridColumns>
              </StyledGridRow>
              <StyledGridRow>
                <Grid.Column>{t('Sent at')}</Grid.Column>
                <StyledGridColumns>{showData?.sentAt ? formatSendDate(showData?.sentAt) : '-'}</StyledGridColumns>
              </StyledGridRow>
              <StyledGridRow>
                <Grid.Column>{t('Time Schedule')}</Grid.Column>
                <StyledGridColumns>{dayjs(showData?.sendDate).format(('DD.MM.YYYY HH:mm'))}</StyledGridColumns>
              </StyledGridRow>
              <StyledGridRow>
                <Grid.Column>{t('Created at')}</Grid.Column>
                <StyledGridColumns>{dayjs(showData?.createdAt).format(('DD.MM.YYYY HH:mm'))}</StyledGridColumns>
              </StyledGridRow>
            </Grid>
          </Grid.Column>
          <Grid.Column>
            <Grid columns={2} stackable>
              <StyledGridRow verticalAlign='top'>
                <Grid.Column>{t('Farmer groups')}</Grid.Column>
                <StyledGridColumns>{showFarmerGroups(showData?.farmerGroups)}</StyledGridColumns>
              </StyledGridRow>
              <StyledGridRow verticalAlign='top'>
                <Grid.Column>{t('Additional recipients')}</Grid.Column>
                <StyledGridColumns style={{ margin: '0px 14px' }}>{showAdditionalRecipients(showData?.additionalRecipients)}</StyledGridColumns>
              </StyledGridRow>
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </StyledSegment>;
  }

  return <>
    {showData ? renderDetails() : null}
  </>;

};
export default ShowInfo;
